import clsx from 'clsx';
import {Dialog} from '@headlessui/react';
import {useEffect, useState} from 'react';
interface SkiTestVideoProps {
  component: any;
}

export function SkiTestVideo({component}: SkiTestVideoProps) {
  const [isOpen, setIsOpen] = useState(false);
  const videoId = component?.url?.replace('https://youtu.be/', '');
  const url = `//www.youtube.com/embed/${videoId}`;
  const srcModal = `${url}?autoplay=1&loop=1&playlist=${videoId}&controls=1&mute=0`;

  function onPlayerReady(event: any) {
    event.target.setPlaybackRate(Number(0.5));
    event.target.playVideo();
  }

  function onPlayerStateChange(event: any) {
    if (event.data == YT.PlayerState.ENDED) {
      event.target.seekTo(component.start_offset);
    }
  }

  window.onYouTubeIframeAPIReady = function () {
    new YT.Player('player', {
      height: '315',
      width: '560',
      videoId,
      playerVars: {
        playsinline: 1,
        loop: 1,
        controls: 0,
        mute: 1,
        start: component.start_offset,
        end: component.start_offset + component.length,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  };

  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      const body = document.getElementsByTagName('body')[0];
      body.appendChild(tag);
    } else {
      window.onYouTubeIframeAPIReady();
    }
  });

  if (!component?.quote) {
    return null;
  }

  return (
    <div className="full-width-bars" id="st-video">
      <div className="video ">
        <div id="ski-video" className="">
          <div id="player"></div>
        </div>
        <div
          className={clsx('flex justify-center items-center absolute inset-0', {
            'bg-black/70 md:bg-transparent': component?.url,
          })}
        >
          <div className="message m-auto max-w-7xl flex flex-col justify-center p-5">
            <div
              className={clsx(
                'font-libre-baskerville font-bold text-lg lg:text-3xl',
                {
                  'text-white': component?.url,
                  'text-black': !component?.url,
                },
              )}
            >
              {component.quote}
            </div>
            <div
              className={clsx(
                'font-libre-baskerville text-base lg:text-lg mt-2 lg:mt-4 text-white pl-3',
                {
                  'text-white': component?.url,
                  'text-black': !component?.url,
                },
              )}
            >
              {component.tester_name}
            </div>
            {component?.url && (
              <>
                <button
                  className="flex relative top-1 md:top-10 py-1 px-2 mx-auto"
                  onClick={() => setIsOpen(true)}
                >
                  <svg
                    version="1.1"
                    id="YouTube_Icon"
                    x="0px"
                    y="0px"
                    width="70px"
                    height="70px"
                    viewBox="0 0 1024 721"
                    enableBackground="new 0 0 1024 721"
                    xmlSpace="preserve"
                  >
                    <path
                      id="Triangle"
                      fill="#FFFFFF"
                      d="M407,493l276-143L407,206V493z"
                    />
                    <path
                      id="The_Sharpness"
                      opacity="0.12"
                      fill="#420000"
                      d="M407,206l242,161.6l34-17.6L407,206z"
                    />
                    <g id="Lozenge">
                      <g>
                        <linearGradient
                          id="SVGID_1_"
                          gradientUnits="userSpaceOnUse"
                          x1="512.5"
                          y1="719.7"
                          x2="512.5"
                          y2="1.2"
                          gradientTransform="matrix(1 0 0 -1 0 721)"
                        >
                          <stop offset="0" style={{stopColor: '#E52D27'}} />
                          <stop offset="1" style={{stopColor: '#BF171D'}} />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_1_)"
                          d="M1013,156.3c0,0-10-70.4-40.6-101.4C933.6,14.2,890,14,870.1,11.6C727.1,1.3,512.7,1.3,512.7,1.3
			h-0.4c0,0-214.4,0-357.4,10.3C135,14,91.4,14.2,52.6,54.9C22,85.9,12,156.3,12,156.3S1.8,238.9,1.8,321.6v77.5
			C1.8,481.8,12,564.4,12,564.4s10,70.4,40.6,101.4c38.9,40.7,89.9,39.4,112.6,43.7c81.7,7.8,347.3,10.3,347.3,10.3
			s214.6-0.3,357.6-10.7c20-2.4,63.5-2.6,102.3-43.3c30.6-31,40.6-101.4,40.6-101.4s10.2-82.7,10.2-165.3v-77.5
			C1023.2,238.9,1013,156.3,1013,156.3z M407,493V206l276,144L407,493z"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
                <Dialog
                  open={isOpen}
                  onClose={() => setIsOpen(false)}
                  className="relative z-50"
                >
                  <div className="fixed inset-0 flex w-screen items-center justify-center">
                    <Dialog.Panel className="shadow-[0_2px_7px_0_rgba(0,0,0,0.2)] rounded-xl bg-white px-3 py-12 lg:p-12 relative min-w-[300px] w-[calc(100%-20px)] md:w-[75vw]">
                      <div className="relative h-0 pb-[56.25%] w-full">
                        <iframe
                          className="absolute top-0 left-0 w-full h-full"
                          title="Video"
                          height="315"
                          width="560"
                          src={srcModal}
                          allowFullScreen
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          frameBorder="0"
                        />
                      </div>

                      <button
                        className="absolute top-2 right-2"
                        onClick={() => setIsOpen(false)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-8 h-8"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                      </button>
                    </Dialog.Panel>
                  </div>
                </Dialog>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
